export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_SYMBOL_CURRENCY = '$';
export const DEFAULT_DISTANCE_UNIT = '"';
export const DEFAULT_WEIGHT_UNIT = 'LBS';
